import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/users/' // (7) 사용자 메모 목록 조회

let swrData: any = getPersistData(KEY)

export function useUserMemo(userId) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + userId + '/memo?page=1&maxData=99999999',
		async () => {
			const response = await API.get(KEY + userId + '/memo?page=1&maxData=99999999', token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		userMemoList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}